import React, { useEffect } from "react";

const DeveloperPageSeo = ({ developerName = "" }) => {
  useEffect(() => {
    console.log("DeveloperPageSeo prop:", developerName);
  }, [developerName]);

  return (
    <>
      {developerName === "The House of Abhinandan Lodha" && (
        <div className="devloper-name-property-div">
          <div className="">
            <h1 className="configuration-txt">
              About The House of Abhinandan Lodha
            </h1>
          </div>
          <p className="project-overview-txt">
            HoABL residential properties offer legally secure "branded land" and
            "growth housing" through a 100% digital-first model, providing
            infrastructure-ready developments in high-growth corridors such as
            Ayodhya, Goa, and Mumbai. HOABL properties offer a "New Generation
            Land" experience by providing tech-enabled, legally secure, and
            infrastructure-ready plotted developments across India's most
            high-growth and culturally significant locations. Lodha Properties
            is a leading Indian real estate developer dedicated to "Building a
            Better Life" by delivering premium, sustainable, and architecturally
            iconic residential and commercial landmarks across major
            metropolitan hubs like Mumbai, Pune, and Bengaluru. Lodha
            residential properties represent India's premier luxury housing
            portfolio, offering a "Better Life" through architecturally iconic,
            sustainable, and amenity-rich gated communities across Mumbai, Pune,
            and Bengaluru, with a planned expansion into Delhi-NCR by March
            2026.
          </p>
        </div>
      )}
      {developerName === "Pride Purple Properties" && (
        <div className="devloper-name-property-div">
          <div className="">
            <h1 className="configuration-txt">About Pride Purple Properties</h1>
          </div>
          <p className="project-overview-txt">
            Pride Purple Properties is about much more than just construction;
            it's about helping families find a place where they truly belong in
            Pune. Over the years, the Pride Purple Group has become a familiar,
            trusted name, creating neighborhood hubs and high-end spaces that
            genuinely make daily life easier and more enjoyable. For the 100,000
            people who already call their developments home, the Pride Purple
            name represents a promise of a better, more fulfilling lifestyle.
            When you walk into any of the Pride Purple luxury flats Pune, you
            can feel that it's more than just a building because it is a
            sanctuary designed with your comfort and peace of mind at the
            center. Pride Purple Properties Pune is a premier real estate brand
            dedicated to delivering "#TheBetterLife" through a diverse portfolio
            of over 50 residential and commercial landmarks across the city's
            most strategic growth hubs.
          </p>
          <p className="project-overview-txt">
            There is a genuine sense of excitement with every pride purple new
            project because they constantly find new ways to make city living
            feel fresh and effortless. By blending sleek designs with amenities
            that actually matter to modern families, they ensure that every home
            they build becomes a special place where your favorite life stories
            can unfold.
          </p>
        </div>
      )}
      {developerName === "Nyati Group" && (
        <div className="devloper-name-property-div">
          <div className="">
            <h1 className="configuration-txt">About Nyati Group</h1>
          </div>
          <p className="project-overview-txt">
            Nyati Group is a group of people who love building places for
            families. Nyati Group Pune is more than just a developer; they are a
            team that has spent 28 years helping neighbors find a place to call
            home in the city's best locations. As trusted Nyati Builders, they
            put people and transparency first, having already helped over 11,000
            families settle into welcoming communities built to last for
            generations. For nearly three decades, Nyati Pune has been helping
            the city feel like home by building the kind of friendly, welcoming
            neighborhoods where families can truly settle down and make memories
            together. By focusing on neighborhoods that feel like real
            communities, Nyati projects in Pune provide the kind of welcoming
            spaces where families can truly plant roots. Nyati residential
            projects are designed with the understanding that a house is only
            complete when it's filled with your family's laughter and daily
            life. By creating cozy, secure neighborhoods that feel like real
            communities, they provide a warm and reliable place for you to
            settle down, find your peace, and build a future with the people you
            love most.
          </p>
        </div>
      )}
      {developerName === "Austin Realty" && (
        <div className="devloper-name-property-div">
          <div className="">
            <h1 className="configuration-txt">About Austin Realty</h1>
          </div>
          <p className="project-overview-txt">
            Austin Realty Group Pune is a well-known real estate developer in
            the Pimpri-Chinchwad (PCMC) region that specializes in building
            excellent residential and business spaces that blend modern
            architecture with useful design. Every Austin Realty residential
            project is built with the belief that a home should be your favorite
            place to be, offering a perfect mix of private sanctuaries and
            lively community spaces. The new projects Austin Realty is launching
            are about more than just fresh construction; they are exciting new
            chapters for families looking to plant roots in thriving areas like
            Tathawade. Realty Austin was established in 2014 and has
            consistently prioritized fulfilling our clients' exact desires since
            our inception. Austin Realty Group: Over the past five years, this
            commitment has propelled us to establish a strong presence. Austin
            Realty Pune ensures that you will find a place to call home. Austin
            Realty residential projects are high-quality housing developments
            located throughout the Pune and PCMC regions.
          </p>
        </div>
      )}
      {developerName === "Malpani Properties" && (
        <div className="devloper-name-property-div">
          <div className="">
            <h1 className="configuration-txt">About Malpani Group</h1>
          </div>
          <p className="project-overview-txt">
            Malpani Group is a widely diversified company house operating in
            renewable energy, FMCG items, amusement and water parks, real
            estate, hotels, etc. More than homes, Malpani Group luxury flats
            Pune are spaces where success feels personal. Malpani Group Pune
            unwavering dedication to the pleasure of our clients as well as the
            community by way of sharing the advantages with all has been and
            always will be the key to our amazing growth. Malpani Group
            residential projects are designed for those who value lasting
            quality, thoughtful planning, and homes that grow with you. Malpani
            apartments in Pune refer to a diverse collection of residential
            developments by the Malpani Group, known for blending luxury with
            functional urban living across key neighborhoods like Baner,
            Balewadi, and Phursungi.
          </p>
        </div>
      )}
      {developerName === "Mantra Properties" && (
        <div className="devloper-name-property-div">
          <div className="">
            <h1 className="configuration-txt">About Mantra Properties</h1>
          </div>
          <p className="project-overview-txt">
            Since 2007, Mantra Properties has delivered thoughtfully designed
            homes for 7,500+ families across Pune and PCMC, with Mantra luxury
            flats Pune offering a refined standard of modern urban living. They
            focus on creating modern, sun-filled homes that act as a sanctuary
            from the busy world, giving you a peaceful and harmonious space to
            enjoy a better, more relaxed way of life with the people you love.
            Mantra apartments in Pune are more than just well-planned spaces;
            they are warm, inviting homes where the stresses of the day melt
            away. Every room is designed to make your daily life feel easier and
            more comfortable, giving your family a modern sanctuary where you
            can truly relax and enjoy your time together. Mantra Properties Pune
            isn't just trying to grow; they are passionate about rethinking how
            homes are built by putting your needs at the heart of everything
            they do. The new projects Mantra Properties is launching are about
            more than just fresh construction; they are an invitation for
            families to step into a home that truly understands how we live
            today. Driven by vision and precision, Mantra Builders shapes spaces
            that elevate everyday living.
          </p>
        </div>
      )}
      {developerName === "Balaji Solitaire" && (
        <div className="devloper-name-property-div">
          <div className="">
            <h1 className="configuration-txt">About Balaji Solitaire</h1>
          </div>
          <p className="project-overview-txt">
            Balaji Solitaire residential properties in Mumbai offer thoughtfully
            designed homes in well-connected locations, combining modern living
            spaces with essential amenities and convenient access to everyday
            necessities. Balaji Solitaire Mumbai presents residential
            opportunities for homebuyers looking for quality housing in Mumbai
            and its surrounding areas. The developer's portfolio includes
            projects such as Balaji Vrindavan, offering contemporary residential
            apartments in Sonar Pada, Dombivli.
          </p>
        </div>
      )}
    </>
  );
};

export default DeveloperPageSeo;
